<template>
    <div class="notifications-container">
        <div :class="'callout shadow-notification notification notification-'+type" data-closable="" data-animate="slide-in-down slide-out-up">
            <div class="bubble"></div>
            <h2>{{ title }}</h2>
            <p>{{ description }}</p>
            <button class="close-button" aria-label="Dismiss alert" type="button" data-close="">
            <svg xmlns="http://www.w3.org/2000/svg" height="14.971" width="14.972" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                <path d="M7.486 0a7.483 7.483 0 00-5.292 12.779A7.486 7.486 0 0012.78 2.194 7.439 7.439 0 007.486 0zm4.316 11.802a6.112 6.112 0 01-8.63 0 6.101 6.101 0 118.63-8.629 6.102 6.102 0 010 8.629zm-1.358-7.288a.688.688 0 00-.979 0L7.477 6.502 5.372 4.398a.692.692 0 00-.978.977L6.5 7.48 4.395 9.584a.69.69 0 00.493 1.18.7.7 0 00.484-.198L7.48 8.458l1.99 1.988a.7.7 0 00.977.004l.002-.004a.688.688 0 000-.978L8.461 7.48l1.996-1.997a.697.697 0 00-.013-.969z" fill="#9babc5" fill-rule="nonzero"></path>
            </svg>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name:'Notification-Component',
    props:['type' , 'title' , 'description']
}
</script>
